export class UseType {
  private key: string;
  private value: string;
  public getKey(): string {
    return this.key;
  }
  public setKey(value: string): void {
    this.key = value;
  }
  public getValue(): string {
    return this.value;
  }
  public setValue(value: string): void {
    this.value = value;
  }
}
